import DatePicker from 'vue2-datepicker'
import custom from '@/custom';
import codes from '@/codes';
import { Switch as cSwitch } from '@coreui/vue';
import moment from 'moment-timezone';
import vSelect from 'vue-select';

//restful api
import { system as wsfinder } from '@/service/api/wsfinder'

const default_opt = () => ({
  perPage: 10, //limit,
  currentPage: 1, //
  totalRows: 0,
  cmd : "search",
  request : "wsf",
  offset : 0,
  limit : 10,
  adv : false,
  sk : '', "sv" : '', "skt" : '', "opt" : { },
  body : {
    sort : [ { name : "group_id" }, { name : "id", op : "desc" } ]
  }
})

const i18n_fields = {
  EN: [
    { key: 'id', label: '#.', sortable: false, thStyle: 'width: 5%' },
    { key: 'created_at', label: 'Registed_at', sortable: true, thStyle: 'width: 12%' },
    { key: 'is_alive', label: 'Status', sortable: true, thStyle: 'width: 12%' },
    { key: 'category', label: 'Category', sortable: true, thStyle: 'width: 12%' },
    { key: 'ext', label: 'Ext', sortable: true, thStyle: 'width: 12%' },
    { key: 'type', label: 'Type', sortable: true, thStyle: 'width: 12%' },
    { key: 'code', label: 'Code', sortable: true },
  ],
  KO: [
    { key: 'id', label: '#.', sortable: false, thStyle: 'width: 5%' },
    { key: 'created_at', label: '등록일', sortable: true, thStyle: 'width: 12%' },
    { key: 'is_alive', label: '상태', sortable: true, thStyle: 'width: 12%' },
    { key: 'category', label: '분류', sortable: true, thStyle: 'width: 12%' },
    { key: 'ext', label: '확장자', sortable: true, thStyle: 'width: 12%' },
    { key: 'type', label: '타입', sortable: true, thStyle: 'width: 12%' },
    { key: 'code', label: '코드', sortable: true },
  ]
}

export default {
  components: { DatePicker, vSelect, cSwitch },
  name : "systemPattern",
  props : ["auto_refresh", "enable_new", "view_detail", "partner", "addPartner"],
  data: () => {
    return {
      group_name :'',
      custom,
      codes,
      so : default_opt(),
      model : { total : 0, enable : 0, disable : 0, S : 0, U : 0, R : 0, M : 0 },
      sync : { interval : 15, stop : false, th : undefined },
      nbsp : "\u00A0",
      hide_del : true,
    }
  },
  computed: {
    fields : function() {
      return i18n_fields[this.i18n];
    },
    rowCount: function() { return this.so.totalRows || 0; },
    startRow : function() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; }
  },
  methods: {
    add_pattern() {
      if(this.addPartner === true) {
        this.$router.push({ name: 'wsfinder_spattern', params: { id : this.$route.params.id } })
      } else {
        this.$router.push({ name: 'wsfinder_spattern', params: { id : 'add' } })
      }
    },
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day").startOf('d');
        this.so.opt['match_type'] = 'and';
        this.so.sv = '';
      } else { this.reset(); }
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt);
    },
    set_op(k, v, equal=false) {
      if(equal) {
        return { name : k, value : v, op : '=' }
      }
      else if(['level', 'mode', 'group_id'].indexOf(k) > -1) {
        // console.log({ name : k, value : parseInt(v, 10), op : '=' })
        return { name : k, value : parseInt(v, 10), op : '=' };
      } else if(v == 'false' || v == 'true') {
        return { name : k, value : v === "false" ? false : true, op : '=' }
      }

      return { name : k, value : `%${v}%`, op : 'like' }
    },
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() { console.log('refresh'); this.$refs._list.refresh(); },
    getItems: function(ctx) { return this.load(ctx); },
    async load(ctx = {}) {
      let so = {
        // target : 'wsfinder.pattern', cmd : 'list',
        body : { sort : [{ name : "id", op : "desc" }], or : [], and : [] },
        offset : (this.so.currentPage-1 || 0) * Number(this.so.perPage), limit: Number(this.so.perPage), // 10 은 나중에 변수 처리해야함.
      }
      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.so.sk && (this.so.sv || '').trim()) { so.body.and = [ { name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' } ] }

      if(this.partner) { so.body.and.push({ name : "partner_id", Value : this.partner.id, op : "=" }) }
      if(this.hide_del) { so.body.and.push({ name : "is_del", Value : false, op : "=" }) }

      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'is_del':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'type':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'category':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'ext':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'created_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'created_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if( cond.value == '-' || cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
      }
        return wsfinder.listSys(so).then(rs => {
        this.so.totalRows = rs.total;
        return rs.body;
      }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    detail: function(item) {
      this.$router.push({ name : 'wsfinder_spattern', params : { id: item.id } })
    },
    summary() {
      let and = [];
      wsfinder.summarySys({ and : and, or : [], sort : [] })
        .then(rs => { if(rs.error) { return this.$toastr.e(rs.reason, this.$route.name) } else { this.model = Object.assign(this.model, rs.body) } })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
  },
  watch: { '$route' (to, from) { console.log(`from : ${from}`); this.$on('refresh', this.refresh()) } },
  created: function() { console.log('spattern.list.vue', 'created'); },
  destroyed: function() { console.log('spattern.list.vue', 'destroyed'); },
  mounted: function() {
    console.log('spattern.list.vue', 'mounted');
    if(this.view_detail !== false) { setTimeout(this.summary, 1000) }
  },
}